import React from "react";
import { ageCalculate } from "../utils/utils.js";

const getFieldStatus = (row, pendingKey, statKey) => {
  if (row?.[pendingKey]) return "Pending";
  if (row?.[statKey] === "Rejected") return "Rejected";
  if (row?.[statKey] === "Approved") return "Verified";
  return "Pending";
};

const hasUserPhoto = (row) => {
  if (!row) return false;
  const photoFields = [
    "photo", "photo1", "photo2", "photo3", "photo4",
    "pending_photo", "pending_photo_1", "pending_photo_2", "pending_photo_3", "pending_photo_4"
  ];
  return photoFields.some(
    (field) => Boolean(row[field] && row[field] !== "null" && typeof row[field] === "string" && row[field].trim() !== "")
  );
};

export const profileApprovalColumns = ({
  PAGE_SIZE,
  handleProfileStatusChange,
  viewPhoto
}) => [
    {
      label: "Profile ID",
      width: 90,
      render: (row) => (
        <div style={{ fontSize: 12, fontWeight: 600 }}>
          {row.profile_id || "-"}
        </div>
      ),
    },
    {
      label: "User Details",
      width: 220,
      render: (row) => (
        <div className="userdet" style={{ fontSize: 12 }}>
          <div>
            <i className="far fa-user" /> {row.name || "-"}
          </div>
          <div>
            <i className="far fa-mobile" /> {row.contact_no || row.mobile || "-"}
          </div>
          <div style={{ wordBreak: "break-all" }}>
            <i className="far fa-envelope" /> {row.contact_email || row.email || "-"}
          </div>
          <div>
            <i className="far fa-mars" /> {row.gender || "-"}
          </div>
          <div>
            <i className="far fa-calendar-alt" /> {row.dob ? `${ageCalculate(row.dob)} Yrs old` : "-"}
          </div>
        </div>
      ),
    },
    {
      label: "Updated Gender",
      width: 110,
      render: (row) => (
        <div style={{ maxHeight: 80, overflow: "hidden", fontSize: 12 }}>
          {row.pending_gender || "----"}
        </div>
      ),
    },

    {
      label: "Updated About Me",
      width: 180,
      render: (row) => (
        <div style={{ maxHeight: 100, overflowY: "auto", fontSize: 12, wordWrap: "break-word", whiteSpace: "normal" }} >
          {row.pending_aboutMe || "----"}
        </div>
      ),
    },
    {
      label: "Gender Status",
      width: 125,
      render: (row) => {
        const status = getFieldStatus(row, "pending_gender", "gender_status");
        const hasPending = Boolean(row?.pending_gender);

        return (
          <div>
            {hasPending ? (
              <div style={{ fontSize: 11, marginBottom: 4 }}>
                Pending: {row.pending_gender}
              </div>
            ) : null}
            {hasPending ? (
              <select
                value={status}
                onChange={(e) => handleProfileStatusChange(row, e.target.value, "gender")}
                style={{ fontSize: "11.5px", padding: "3px 4px", borderRadius: "4px", width: "100%" }}
              >
                <option value="Pending">Pending</option>
                <option value="Approved">Approved</option>
                <option value="Rejected">Rejected</option>
              </select>
            ) : (
              <span style={{ fontSize: 12 }}>---</span>
            )}
          </div>
        );
      },
    },
    {
      label: "About Me Status",
      width: 125,
      render: (row) => {
        const status = getFieldStatus(row, "pending_aboutMe", "about_status");
        const hasPending = Boolean(row?.pending_aboutMe);

        return (
          <div>
            {hasPending ? (
              <select
                value={status}
                onChange={(e) => handleProfileStatusChange(row, e.target.value, "about")}
                style={{ fontSize: "11.5px", padding: "3px 4px", borderRadius: "4px", width: "100%" }}
              >
                <option value="Pending">Pending</option>
                <option value="Approved">Approved</option>
                <option value="Rejected">Rejected</option>
              </select>
            ) : (
              <span style={{ fontSize: 12 }}>---</span>
            )}
          </div>
        );
      },
    },
    {
      label: "Profile Status",
      width: 120,
      render: (row) => (
        <select
          value={row.profileApproval || "Pending"}
          onChange={(e) => handleProfileStatusChange(row, e.target.value, "profile")}
          disabled={row.profileApproval === "Rejected" || row.profileApproval === "Approved"}
          style={{
            fontSize: "11.5px",
            padding: "3px 4px",
            borderRadius: "4px",
            width: "100%",
            cursor: row.profileApproval === "Rejected" ? "not-allowed" : "pointer",
            backgroundColor: row.profileApproval === "Rejected" ? "#f5f5f5" : "#fff",
          }}
        >
          <option value="Pending">Pending</option>
          <option value="Approved">Approved</option>
          <option value="Rejected">Rejected</option>
        </select>
      ),
    },
    {
      label: "View Photo",
      width: 105,
      render: (row) => {
        const hasPhoto = hasUserPhoto(row);

        if (hasPhoto) {
          return (
            <span
              style={{
                backgroundColor: "#108908",
                color: "#ffffff",
                padding: "2px 8px",
                borderRadius: "15px",
                fontSize: "11px",
                fontWeight: 500,
                display: "inline-block",
                cursor: "pointer",
                textAlign: "center",
                userSelect: "none",
                whiteSpace: "nowrap"
              }}
              onClick={() => viewPhoto(row)}
            >
              View Photo
            </span>
          );
        }

        return (
          <span
            style={{
              backgroundColor: "#d5d8dc",
              color: "#6c757d",
              padding: "2px 8px",
              borderRadius: "15px",
              fontSize: "11px",
              fontWeight: 500,
              display: "inline-block",
              cursor: "not-allowed",
              textAlign: "center",
              userSelect: "none",
              border: "1px solid #c8cbcf",
              whiteSpace: "nowrap"
            }}
            title="No photo available"
          >
            View Photo
          </span>
        );
      },
    },
  ];
